import React, { Component, Fragment } from "react";

import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  injectStripe,
  StripeProvider,
  Elements,
} from "react-stripe-elements";
import { withRouter } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Image,
  Table,
  Alert,
} from "react-bootstrap";
import { toast } from "react-toastify";

import { STRIPE_PK } from "../../Actions/ApiUrls";

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: "16px",
        color: "#424770",
        letterSpacing: "0.025em",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#c23d4b",
      },
    },
  };
};

class _SplitFieldsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      loading: false,
      disabled: false,
    };
  }

  handleChange = ({ error }) => {
    if (error) {
      this.setState({ errorMessage: error.message });
    }
  };
  onDismiss() {
    this.setState({
      alertVisible: false,
      alertMessage: "",
      alertClass: "success",
      successMessage: "",
    });
  }

  handleSubmit = async (evt) => {
    evt.preventDefault();
    this.setState({ loading: true, disabled: true });

    if (this.props.stripe) {
      let { token, error } = await this.props.stripe
        .createToken()
        .then(this.props.handleResult);
      setTimeout(() => {
        this.setState({ loading: false, disabled: false });
      }, 2000);
      if (token) {
        this.props.getToken(token);
        setTimeout(() => {
          this.setState({ loading: false, disabled: false });
        }, 2000);
      }
    } else {
      toast.success("Please try after some time");
      setTimeout(() => {
        this.setState({ loading: false, disabled: false });
      }, 2000);
    }
  };

  render() {
    const { loading, errorMessage, disabled } = this.state;
    const {stripeDisabled}= this.props;
    return (
      <Fragment>
        <form
          onSubmit={this.handleSubmit.bind(this)}
          className="chekZipcode stripe-card"
        >
          <Row style={{ padding: 15 }}>
            <Col md="12" xs="12">
              <div class="form-group">
                <label>Card number </label>
                <CardNumberElement
                  className="form-control"
                  {...createOptions()}
                  onChange={this.handleChange}
                />
              </div>
            </Col>
            <Col md="12" xs="12">
              <div class="form-group">
                <label>Expiration date</label>
                <CardExpiryElement
                  className="form-control"
                  {...createOptions()}
                  onChange={this.handleChange}
                />
              </div>
            </Col>
            <Col md="12" xs="12">
              <div class="form-group">
                <label>CVC</label>
                <CardCVCElement
                  className="form-control"
                  {...createOptions()}
                  onChange={this.handleChange}
                />
              </div>
            </Col>
            <Col md="12" xs="12">
              <Button
                variant="raised"
                color="primary"
                type="submit"
                className="order-pay"
                disabled={stripeDisabled}
              >
                <h5>SUBMIT PAYMENT</h5>
              </Button>
            </Col>
            <Col>
              <span style={{ color: "#af2525" }}>{errorMessage}</span>
            </Col>
          </Row>
        </form>
      </Fragment>
    );
  }
}

const SplitFieldsForm = injectStripe(_SplitFieldsForm);

class SplitFields extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <StripeProvider apiKey={STRIPE_PK}>
        <Elements>
          <SplitFieldsForm
            handleResult={this.props.handleResult}
            history={this.props.history}
            getToken={this.props.getToken}
            stripeDisabled={this.props.stripeDisabled}
          />
        </Elements>
      </StripeProvider>
    );
  }
}
export default withRouter(SplitFields);
